export function LogoutIcon({
  size = 17,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 17V0H8.5095V1.5H1.5V15.5H8.5095V17H0ZM12.7308 12.7692L11.6923 11.6845L14.127 9.25H5.59625V7.75H14.127L11.6923 5.3155L12.7308 4.23075L17 8.5L12.7308 12.7692Z"
        fill="#E31E24"
      />
    </svg>
  );
}
